import { render } from "./Activation.vue?vue&type=template&id=01cb4f45&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"

import "./Activation.vue?vue&type=style&index=0&id=01cb4f45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cb4f45"]])

export default __exports__